<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1098_16704)">
			<path
				d="M8.00033 5.33268C8.73366 5.33268 9.33366 4.73268 9.33366 3.99935C9.33366 3.26602 8.73366 2.66602 8.00033 2.66602C7.26699 2.66602 6.66699 3.26602 6.66699 3.99935C6.66699 4.73268 7.26699 5.33268 8.00033 5.33268ZM8.00033 6.66602C7.26699 6.66602 6.66699 7.26602 6.66699 7.99935C6.66699 8.73268 7.26699 9.33268 8.00033 9.33268C8.73366 9.33268 9.33366 8.73268 9.33366 7.99935C9.33366 7.26602 8.73366 6.66602 8.00033 6.66602ZM8.00033 10.666C7.26699 10.666 6.66699 11.266 6.66699 11.9994C6.66699 12.7327 7.26699 13.3327 8.00033 13.3327C8.73366 13.3327 9.33366 12.7327 9.33366 11.9994C9.33366 11.266 8.73366 10.666 8.00033 10.666Z"
				fill="#929497"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1098_16704">
				<rect
					width="16"
					height="16"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

<script>
export default {};
</script>


